<template>
  <Layout>
    <div class="home">

      <!-- HERO -->
      <section class="text-center py-4">
        <div class="text-warning font-weight-bold letter-spacing">
          {{ $t('concept.hero.label') }}
        </div>

        <h1 class="text-primary font-weight-bold mt-3">
          {{ $t('concept.hero.title') }}
        </h1>

        <p class="text-muted mt-3 col-md-8 mx-auto">
          {{ $t('concept.hero.description') }}
        </p>
      </section>

      <!-- FEATURES -->
      <section class="py-3">
        <div class="header-80-width">
          <div class="row">
            <div
              class="col-md-4 my-3"
              v-for="(feature, i) in features"
              :key="i"
            >
              <b-card class="feature-card text-left m-2 h-100 p-0">
                
                <div class="d-flex justify-content-between align-items-center mb-4">

                  <div class="icon-box text-secondary d-flex justify-content-center align-items-center" >
                    <i :class="feature.icon"></i>
                  </div>

                  <div class="feature-number text-secondary font-weight-bold" style="
                      font-size: 60px; 
                      line-height: 1; 
                      color: #f9d406; 
                      text-shadow: 2px 2px 4px rgba(0,0,0,0.1);">
                    0{{ i + 1 }}
                  </div>
                </div>

                <h4 class="font-weight-bold text-primary text-uppercase mb-3">
                  {{ feature.title }}
                </h4>

                <div class="text-muted text-justify" style="letter-spacing: 1.1px;">
                  {{ feature.text }}
                </div>

                <component :is="feature.componentName" />

              </b-card>

            </div>
          </div>
        </div>
      </section>

      <HeroSection class="my-5"></HeroSection>


      <section class="py-5">
        <b-container>
          <div class="text-center mb-5">
            <div class="text-warning font-weight-bold">
              {{ $t('concept.implementation.label') }}
            </div>

            <h2 class="font-weight-bold text-primary mt-2">
              {{ $t('concept.implementation.title') }}
            </h2>
          </div>

          <div class="row">
            <div
              class="col-md-4"
              v-for="(step, i) in steps"
              :key="i"
            >
              <div class="step-box m-2">
                <span class="step-number bg-secondary">{{ i + 1 }}</span>

                <h5 class="font-weight-bold text-primary text-uppercase mt-3">
                  {{ step.title }}
                </h5>

                <p class="text-muted">
                  {{ step.text }}
                </p>
              </div>
            
            </div>
          </div>
        </b-container>
      </section>

    </div>
  </Layout>
</template>



<script>
import Layout from "../../layouts/main";
import concept1 from "../concept/component/concept1.vue";
import concept2 from "../concept/component/concept2.vue";
import concept3 from "../concept/component/concept3.vue";
import HeroSection from "../concept/component/HeroSection";


export default {
    components: {Layout, concept1, concept2, concept3, HeroSection },

  name: 'Home',
  
  data() {
    return {
      features: [
        { title: this.$t('concept.features.menu.title'), text: this.$t('concept.features.menu.text'), icon: "fas fa-utensils", componentName: "concept1" },
        { title: this.$t('concept.features.secure.title'), text: this.$t('concept.features.secure.text'), icon: "fas fa-qrcode", componentName: "concept2" },
        { title: this.$t('concept.features.command.title'), text: this.$t('concept.features.command.text'), icon: "fas fa-lightbulb", componentName: "concept3" },
      ]
    };
  },

  computed: {

    steps() {
      return [
        {
          title: this.$t('concept.implementation.steps.architecture.title'),
          text: this.$t('concept.implementation.steps.architecture.text')
        },
        {
          title: this.$t('concept.implementation.steps.physical.title'),
          text: this.$t('concept.implementation.steps.physical.text')
        },
        {
          title: this.$t('concept.implementation.steps.operational.title'),
          text: this.$t('concept.implementation.steps.operational.text')
        }
      ]
    }
  }

}
</script>

<style scoped>

.header-80-width,
.sub-title-80-width {
  max-width: 95%;
  margin: auto;
}

@media (min-width: 768px) {
  .header-80-width,
  .sub-title-80-width {
    max-width: 85%;
  }
}

@media (min-width: 1000px) {
  .header-80-width,
  .sub-title-80-width {
    max-width: 90%;
  }
}

.letter-spacing {
  letter-spacing: 2px;
}

.feature-card {
  border: none;
  box-shadow: 0 10px 25px rgba(0,0,0,.05);
  padding: 2rem;
  transition: all .3s;
}

.feature-card:hover {
  transform: translateY(-8px);
}

.icon-box {
  width: 60px;
  height: 60px;
  background: #0b1d35;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.cta-section {
  background: #0b1d35;
}

.step-box {
  position: relative;
  padding-left: 50px;
}

.step-number {
  position: absolute;
  left: 0;
  top: 0;
  color: #000;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
</style>
